import React, { FC } from 'react';
import { SortableElement, SortableElementProps } from 'react-sortable-hoc';

export type GridSortableElementProps = {} & SortableElementProps;

const GridSortableElementItem: FC<GridSortableElementProps> = ({ children }) => <>{children}</>;

export default SortableElement(GridSortableElementItem);
